var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_c('div',{staticClass:"success_img"},[_c('span',{staticClass:"common_backgroundImg"})]),_c('div',{staticClass:"success_img"},[_c('a',[_vm._v("恭喜您注册成功")]),_vm._v("! ")])])
}]

export { render, staticRenderFns }